export default __webpack_public_path__ + "static/media/kayaguneribes4.c7516a8f.jpg";